module.exports = __webpack_public_path__ + "static/media/la-horde-noire-2.3fc4ef87.jpg";